import { reactive, computed } from 'vue'

/**
 * 分页组合式函数
 * @param {Object} options 配置选项
 * @param {Number} options.pageSize 默认每页条数
 * @param {Array} options.pageSizes 可选每页条数列表
 * @returns 分页状态和方法
 */
export function usePagination(options = {}) {
  const { pageSize: defaultSize = 20 } = options

  // 分页状态
  const pagination = reactive({
    current: 1,
    size: defaultSize,
    total: 0,
    pages: 0
  })

  // 计算可见页码（显示当前页前后2页）
  const visiblePages = computed(() => {
    const pages = []
    const current = pagination.current
    const total = pagination.pages
    for (let i = Math.max(1, current - 2); i <= Math.min(total, current + 2); i++) {
      pages.push(i)
    }
    return pages
  })

  // 重置到第一页
  const resetPage = () => {
    pagination.current = 1
  }

  // 跳转到指定页
  const goToPage = (page) => {
    if (page < 1 || page > pagination.pages) return
    pagination.current = page
  }

  // 设置每页条数
  const setPageSize = (size) => {
    pagination.size = size
    pagination.current = 1
  }

  // 更新分页数据
  const updatePagination = (data) => {
    pagination.current = data.current || 1
    pagination.size = data.size || defaultSize
    pagination.total = data.total || 0
    pagination.pages = data.pages || 0
  }

  // 获取分页参数
  const getPaginationParams = () => ({
    page: pagination.current,
    size: pagination.size
  })

  return {
    pagination,
    visiblePages,
    resetPage,
    goToPage,
    setPageSize,
    updatePagination,
    getPaginationParams
  }
}
